import { PROCESSED_NOTIFICATION_KINDS } from 'cpool-constants';
import { useTranslation } from 'react-i18next';

import { NotificationItemRow } from './NotificationItemRow';
import { NotificationRowError } from './NotificationRowError';
import { NotificationRowSkeleton } from './NotificationRowSkeleton';
import useLead from '~/features/leadDetails/hooks/useLead';
import { useAcknowledgedDocuments } from '~/features/notifications/hooks/useAcknowledgedDocuments';
import { getNotificationLinkOptions } from '~/features/notifications/utils/getNotificationLinkOptions';

type Props = {
    loanRequestId: string;
    processedAt: number;
    onNavigate?: () => void;
};

export const ProcessedDocumentRow: React.FC<Props> = ({ loanRequestId, onNavigate, processedAt }) => {
    const { t } = useTranslation();
    const lead = useLead(loanRequestId);
    const acknowledgedDocuments = useAcknowledgedDocuments(loanRequestId);

    if (lead.isLoading || acknowledgedDocuments.isLoading) return <NotificationRowSkeleton />;
    if (lead.isError || acknowledgedDocuments.isError) return <NotificationRowError />;
    if (!lead.data?.antragsteller1) return null;

    const count = acknowledgedDocuments.data?.length ?? 0;

    return (
        <NotificationItemRow
            previewName={`${lead.data.antragsteller1.personendaten?.vorname ?? ''} ${
                lead.data.antragsteller1.personendaten?.nachname ?? ''
            }`.trim()}
            previewDetail={t('TOP_HEADER.NOTIFICATIONS.DOCUMENTS_PROCESSED', { count })}
            timestamp={processedAt}
            link={getNotificationLinkOptions(PROCESSED_NOTIFICATION_KINDS.DOCUMENT, loanRequestId)}
            onNavigate={onNavigate}
        />
    );
};
